// Prefer Vite's VITE_API_BASE, fallback to CRA's REACT_APP_API_URL, finally sensible defaults
function getApiBase(): string {
  // Try Vite env first
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const viteBase = (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.VITE_API_BASE) as string | undefined;
  // In CRA, process.env.REACT_APP_* is replaced at build-time. Do not guard on typeof process.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const craBase = (process.env as any)?.REACT_APP_API_URL as string | undefined;
  
  if (viteBase && viteBase.trim().length > 0) return viteBase.replace(/\/$/, '');
  if (craBase && craBase.trim().length > 0) return craBase.replace(/\/$/, '');
  
  // SOLUCIÓN TEMPORAL: Usar directamente la URL del backend hasta que Azure SWA proxy funcione
  if (typeof window !== 'undefined' && window.location.origin.includes('azurestaticapps.net')) {
    return 'https://api-controllimpio-1701-ayhphhe3d0byg8gn.centralus-01.azurewebsites.net/api';
  }
  
  // En desarrollo local, usar el origen actual + /api
  if (typeof window !== 'undefined') {
    return window.location.origin + '/api';
  }
  return 'http://localhost:5200/api';
}

export const config = {
  API_BASE_URL: getApiBase(),
};
